/**
 * @fileoverview CSS module for the StreamingRecorder component that handles audio recording UI
 * @example
 * // Usage in StreamingRecorder component:
 * import styles from './StreamingRecorder.module.css'
 *
 * function StreamingRecorder() {
 *   return (
 *     <div className={styles.container}>
 *
 *     </div>
 *   )
 * }
 */


.container {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-direction: column;
    justify-content: center;
}
